<template>
  <div class="mt-5">
    <v-data-table :headers="headers" :items="tableList" :items-per-page="pagination.perPage"
      :page="pagination.currentPage" hide-default-footer no-data-text="暂无数据" class="paginated-table table-striped">
      <template v-slot:top>
        <v-row justify="space-between">
          <v-col class="d-flex" cols="6" sm="2">
            <v-select v-model="pagination.perPage" :items="pagination.perPageOptions" label="每页显示"></v-select>
          </v-col>
          <v-col class="d-flex" cols="6" sm="2">
            <v-text-field v-model="queryParams.name" label="查找" type="search" class="mb-3" clearable
              style="width: 200px"></v-text-field>
          </v-col>
        </v-row>
      </template>

      <template #[`item.option`]="{ item, index }">
        <v-tooltip bottom color="grey lighten-5">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="success" small @click.native="interfaceEdit(item)">
              <v-icon small v-bind="attrs" v-on="on">mdi-application-brackets</v-icon>
            </v-btn>
          </template>
          <span style="color: black">页面编辑</span>
        </v-tooltip>
        <!-- <v-tooltip bottom color="grey lighten-5">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="success"
              small
              :disabled="!item.bindPages.length"
              @click.native="toRxDrag(item.id, 'view')"
            >
              <v-icon small v-bind="attrs" v-on="on">mdi-eye-outline</v-icon>
            </v-btn>
          </template>
          <span style="color: black">页面预览</span>
        </v-tooltip> -->
        <v-btn icon color="green darken-1" small @click.native="editItem(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
        <v-btn icon color="red darken-1" small @click.native="deleteItem(item, index)">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <div class="d-flex justify-space-between align-center mt-4">
      <p class="card-category">{{ from + 1 }} 到 {{ to }} ，共 {{ total }}</p>
      <pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
        :per-page="pagination.perPage" :total="pagination.total">
      </pagination>
      <v-btn color="success" small @click.stop="handleAdd">新增</v-btn>
    </div>
    <v-dialog v-model="showAddDialog" hide-overlay persistent scrollable max-width="600">
      <v-form ref="form" @submit.prevent="handleSubmit" v-model="valid">
        <v-card class="window-card">
          <v-card-title>
            <span class="md-title" style="color: #67ad5b">{{
              dialogTitle
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="form.name" label="界面名称 *" color="#4caf50"
              :rules="[(v) => !!v || '界面名称不能为空']"></v-text-field>
            <v-text-field v-model="form.identify" label="界面标识 *" color="#4caf50" :rules="[
              (v) => !!v || '界面标识不能为空',
              (v) => checkPropName(v) || '该界面标识名称已存在',
              (v) =>
                checkNameRule(v) ||
                '界面标识名称不合法，请使用数字、_、英文大小写字母命名，不能以数字开头且名称内容不能包含特殊字符',
            ]"></v-text-field>
            <!-- <h6 class="mb-2" v-show="isEditInterFace">界面结构</h6> -->
            <v-treeview v-show="isEditInterFace" rounded hoverable activatable :items="pageTree" return-object transition
              dense @update:active="treeSelected"></v-treeview>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" type="submit">确 定</v-btn>
            <v-btn color="success" @click="handleDialogClose">关 闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="showPageDialog" hide-overlay persistent scrollable max-width="600">
      <v-form ref="pageForm" @submit.prevent="handlePageSubmit" v-model="validPage">
        <v-card class="window-card">
          <v-card-title>
            <span class="md-title" style="color: #67ad5b">新增页面</span>
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="pageForm.name" label="页面名称 *" color="#4caf50" :rules="[
              (v) => !!v || '页面名称不能为空',
              (v) =>
                checkNameRule(v) ||
                '页面名称不合法，请使用数字、_、英文大小写字母命名，不能以数字开头且名称内容不能包含特殊字符',
            ]"></v-text-field>
            <v-text-field v-model="pageForm.key" label="页面标识 *" color="#4caf50"
              :rules="[(v) => !!v || '页面标识不能为空']"></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" type="submit">确 定</v-btn>
            <v-btn color="success" @click="handlePageClose">关 闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
import { Pagination } from "@/components";
import { checkNameRule } from "@/utils/util";
import { mapGetters } from "vuex";
import {
  addInterfacePage,
  allInterfacePage,
  batchDelInterfacePage,
} from "@/api/interface/interface_page";
import { RxDragLocales } from "./RxDragLocales";
import { _Base64encode } from "@/util/base64";
export default {
  name: "IntTab",
  components: { Pagination },
  computed: {
    ...mapGetters(["propList", "interfaceList"]),
    extDataList: {
      get() {
        return this.propList ?? [];
      },
    },
    tableList: {
      get() {
        return this.interfaceList
          ? this.interfaceList.filter((item) =>
            new RegExp(this.queryParams.name).test(item.name)
          )
          : [];
      },
    },
    from() {
      return (this.pagination.currentPage - 1) * this.pagination.perPage;
    },
    to() {
      return this.pagination.currentPage * this.pagination.perPage;
    },
    total() {
      const total = this.tableList ? this.tableList.length : 0;
      this.pagination.total = total;
      return total;
    },
  },
  data() {
    return {
      headers: [
        { text: "界面名称", align: "center", value: "name" },
        { text: "界面标识", align: "center", value: "identify" },
        {
          text: "操作",
          align: "center",
          value: "option",
          width: 100,
          sortable: false,
        },
      ],
      form: {},
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 15, 25],
        total: 0,
      },
      queryParams: {
        name: "",
      },
      valid: false,
      showAddDialog: false,
      isEditInterFace: false,
      dialogTitle: "界面详情",
      currEditIdentify: "",
      // 页面编辑
      showPageDialog: false,
      validPage: false,
      pageForm: {
        name: "",
        key: "",
      },
      pageTree: [],
    };
  },
  watch: {},
  mounted() {
    this.initForm();
  },
  methods: {
    checkPropName(identify) {
      if (this.form.id && identify === this.currEditIdentify) {
        return true;
      }
      return (
        this.interfaceList.findIndex((item) => item.identify === identify) ===
        -1
      );
    },
    checkNameRule,
    /**
     * 表单字段
     */
    initForm() {
      this.form = {
        name: "", // 界面名称
        identify: "", // 界面标识
        bindPages: [], //绑定的页面
      };
    },
    /**
     * 新增/修改提交操作
     */
    async handleSubmit() {
      this.$refs.form.validate();
      if (!this.valid) {
        this.$store.dispatch(
          "global/showWarningMsg",
          "校验未通过，请检查表单填写是否正确"
        );
        return;
      }
      this.$store.dispatch("editorType/setInterface", this.form);
      this.initForm();
      this.showAddDialog = false;
    },
    /**
     * 添加
     */
    handleAdd() {
      this.initForm();
      this.showAddDialog = true;
      this.isEditInterFace = false;
    },
    /**
     * 修改
     */
    editItem(item) {
      console.log(this.extDataList);
      this.currEditIdentify = item.identify;
      this.form = JSON.parse(JSON.stringify(item));
      this.showAddDialog = true;
      this.isEditInterFace = true;
      this.pageTree = [];
      allInterfacePage({ parentId: item.id }).then((res) => {
        const rows = res.data.rows;
        rows.forEach((ele, index) => {
          const pageJSON = JSON.parse(ele.pageJSON).children;
          const child = this.getChildsList([], pageJSON);
          const treeNode = {
            id: ele._id,
            name: ele.name,
            pId: ele.parentId,
            pKey: ele.key,
            children: [
              {
                id: ele._id + index,
                name: "根节点",
                pId: ele.parentId,
                pKey: ele.key,
                children: child,
              },
            ],
          };
          this.pageTree.push(treeNode);
          console.log(this.pageTree);
        });
      });
    },
    getChildsList(child, childList) {
      childList.forEach((item) => {
        const arr = {
          id: item.cId || undefined,
          name: RxDragLocales[item.componentName],
          children: item.children.length
            ? this.getChildsList([], item.children)
            : [],
        };
        child.push(arr);
      });
      return child;
    },
    /**
     * 删除
     */
    async deleteItem(item, index) {
      console.log(item);
      let result = await Swal.fire({
        title: "删除信息",
        text: `界面"${item.name}"被删除后将无法恢复，请确认！`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        buttonsStyling: false,
      });

      if (result.value) {
        this.$store.dispatch("editorType/removeInterface", index);
        batchDelInterfacePage({ parentId: item.id }).then((res) => {
          if (res.code === "200") {
            this.$swal.fire("删除成功", "", "success");
          }
        });
      }
    },
    /**
     * 关闭弹窗
     */
    handleDialogClose() {
      this.$refs.form.resetValidation();
      this.showAddDialog = false;
    },

    /**
     * 界面编辑
     */
    async interfaceEdit(item) {
      if (!item.bindPages.length) {
        // let result = await Swal.fire({
        //   title: "提示信息",
        //   text: `您暂未绑定页面，是否新增绑定？`,
        //   type: "warning",
        //   showCancelButton: true,
        //   confirmButtonClass: "md-button md-success btn-fill",
        //   cancelButtonClass: "md-button md-danger btn-fill",
        //   confirmButtonText: "确 定",
        //   cancelButtonText: "取 消",
        //   buttonsStyling: false,
        // });

        // if (result.value) {
        //   this.showPageDialog = true;
        //   this.form = item;
        // }
        this.form = item;
        let pageJSON = {
          componentName: "Root",
          slots: {},
          children: [],
        };
        let params = {
          name: '默认页面',
          key: 'page_1',
          parentId: this.form.id,
          pageJSON: JSON.stringify(pageJSON),
        };
        addInterfacePage(params).then((res) => {
          if (res.code === "200") {
            this.$swal.fire("新增成功", "", "success");
            this.form.bindPages.push(res.data.parentId);
            // 更新列表绑定的页面
            this.$store.dispatch("editorType/setInterface", this.form);
            // this.showPageDialog = false;
            this.toRxDrag(this.form.id);
          }
        });
      } else {
        this.toRxDrag(item.id);
      }
    },
    /**
     * 提交
     */
    async handlePageSubmit() {
      this.$refs.pageForm.validate();
      if (this.validPage) {
        let pageJSON = {
          componentName: "Root",
          slots: {},
          children: [],
        };
        let params = {
          ...this.pageForm,
          parentId: this.form.id,
          pageJSON: JSON.stringify(pageJSON),
        };
        addInterfacePage(params).then((res) => {
          if (res.code === "200") {
            this.$swal.fire("新增成功", "", "success");
            this.form.bindPages.push(res.data.parentId);
            // 更新列表绑定的页面
            this.$store.dispatch("editorType/setInterface", this.form);
            this.showPageDialog = false;
            this.toRxDrag(this.form.id);
          }
        });
      }
    },
    handlePageClose() {
      this.$refs.pageForm.resetValidation();
      this.showPageDialog = false;
    },
    /**
     * 跳转
     */
    toRxDrag(parmas, option) {
      const attributeBindingOptions = this.extDataList.map((item) => {
        return {
          value: item.id,
          label: item.name,
        };
      });
      switch (option) {
        case "view":
          window.open(
            `${process.env.VUE_APP_UI_PAGE_URL}/preview-render?p=` +
            parmas.pId +
            "&key=" +
            parmas.pKey,
            "_blank"
          );
          break;
        case "node":
          window.open(
            `${process.env.VUE_APP_UI_PAGE_URL}?p=` +
            parmas.pId +
            "&key=" +
            parmas.pKey +
            "&attributeBindingOptions=" +
            encodeURIComponent(
              _Base64encode(JSON.stringify(attributeBindingOptions))
            ),
            "_blank"
          );
          break;
        default:
          window.open(
            `${process.env.VUE_APP_UI_PAGE_URL}?p=` +
            parmas +
            "&attributeBindingOptions=" +
            encodeURIComponent(
              _Base64encode(JSON.stringify(attributeBindingOptions))
            ),
            "_blank"
          );
          break;
      }
    },
    /**
     * 数据结构选择
     */
    async treeSelected(array) {
      console.log(array);
      if (array.length && array[0].pId) {
        let result = await Swal.fire({
          title: "操作提示",
          text: `请选择下一步操作`,
          type: "warning",
          showCancelButton: true,
          confirmButtonClass: "md-button md-success btn-fill",
          cancelButtonClass: "md-button md-danger btn-fill",
          confirmButtonText: "预 览",
          cancelButtonText: "编 辑",
          buttonsStyling: false,
          allowOutsideClick: false,
          showCloseButton: true,
        });

        const params = {
          pId: array[0].pId,
          pKey: array[0].pKey,
        };
        if (result.value) {
          this.toRxDrag(params, "view");
        } else {
          if (result.dismiss === "cancel") {
            this.toRxDrag(params, "node");
          }
        }
      }
    },
  },
};
</script>
